import Vue from 'vue'
import masterApiCall from '@/masteradmin/utils/api'
import { Notification } from 'element-ui'
import { METRICS_TYPE, METRICS_PERIOD } from 'globalUtils/constants'

import { ACTION_GET_METRICS } from '../actions'

import { MUTATION_SET_METRICS_PERIOD, MUTATION_SET_METRICS_TYPE } from '../mutations'

const metricsModule = {
  state: {
    loading: false,
    period: METRICS_PERIOD.MONTH,
    type: METRICS_TYPE.LOAD,
    data: { values: [], labels: [] },
  },

  mutations: {
    [MUTATION_SET_METRICS_PERIOD](state, data) {
      Vue.set(state, 'period', data)
    },

    [MUTATION_SET_METRICS_TYPE](state, data) {
      Vue.set(state, 'type', data)
    },

    setData(state, metrics) {
      // Initialize values and labels
      const values = Array(metrics.length).fill(0)
      const labels = Array(metrics.length).fill('')

      const isMonthly = state.period === METRICS_PERIOD.YEAR

      // Map the data to populate values
      metrics.forEach((item, i) => {
        values[i] = item.value
        labels[i] = isMonthly
          ? new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short' }).format(new Date(item.date))
          : new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit' }).format(new Date(item.date))
      })
      Vue.set(state, 'data', { values, labels })
    },

    setLoading(state, isLoading) {
      Vue.set(state, 'loading', isLoading)
    },
  },

  actions: {
    [ACTION_GET_METRICS](
      { commit },
      { code, type = METRICS_TYPE.LOAD, period = METRICS_PERIOD.MONTH },
    ) {
      commit('setLoading', true)
      const params = new URLSearchParams({
        code,
        type,
        period,
      }).toString()

      return new Promise((resolve, reject) => {
        masterApiCall('get', `/masteradmin/metrics?${params}`).then(
          ({ data }) => {
            commit('setData', data)
            commit('setLoading', false)
            resolve()
          },
          () => {
            Notification.error({
              title: 'Error!',
              message: 'Unable to retrieve course metrics.',
              position: 'bottom-right',
            })
            commit('setLoading', false)
            reject()
          },
        )
      })
    },
  },
}

export default metricsModule



// WEBPACK FOOTER //
// ./client/masteradmin/store/metricsModule/index.js